import DiplatCard from './DiplatCard';

export default DiplatCard;
